import * as React from "react";
import { useTranslation } from "react-i18next";
import Select from "components/common/Select";
import Direction from "views/logic/aggregationbuilder/Direction";
const SortDirectionSelect = ({ direction = void 0, disabled = false, onChange = () => {
} }) => {
  const { t } = useTranslation("widgets");
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      disabled,
      clearable: false,
      options: [
        { label: t("sort_direction.ascending"), value: "Ascending" },
        { label: t("sort_direction.descending"), value: "Descending" }
      ],
      onChange: (value) => onChange(Direction.fromString(value)),
      placeholder: disabled ? t("sort_direction.no_sorting") : t("sort_direction.select_direction"),
      value: direction != null ? direction : null
    }
  );
};
export default SortDirectionSelect;
